// RFC 9457 problem document, as returned by the Kanguro Claims API
export type ApiProblemBody = {
  type?: string
  title?: string
  status?: number
  detail?: string
  /** Validation failures; `pointer` names the form part, e.g. `#/invoice_date` */
  errors?: { pointer: string; detail: string }[]
  /** On `claim-not-fileable`: what the claim still lacks */
  missing_fields?: { code: string; label: string }[]
}

export class ApiProblemError extends Error {
  readonly status: number
  readonly problem: ApiProblemBody

  constructor(status: number, problem: ApiProblemBody) {
    super(problem.detail ?? problem.title ?? `Request failed: ${status}`)
    this.name = 'ApiProblemError'
    this.status = status
    this.problem = problem
  }

  /** Field names (form part names) that failed validation */
  get fieldErrors(): Record<string, string> {
    return Object.fromEntries(
      (this.problem.errors ?? []).map(({ pointer, detail }) => [
        pointer.replace(/^#\//, '').split('/')[0] ?? pointer,
        detail,
      ]),
    )
  }
}

export async function toApiProblemError(
  response: Response,
): Promise<ApiProblemError> {
  try {
    return new ApiProblemError(
      response.status,
      (await response.json()) as ApiProblemBody,
    )
  } catch {
    return new ApiProblemError(response.status, { status: response.status })
  }
}
